import React from 'react'
import { withTranslation } from "react-i18next";
import Title from "../common/Title"
import Description from "../common/Description"
import getParameter from "../common/getParam"

const SuccessScreen = (props) => {
    const { t } = props;

    return ( 
        <section id="success-screen">
            <div className="loginIntroTextContainer">
                <Title title={"thank_you"}/>
                <Description description={props.description}/>
            </div>
            <button id="success-submit-btn" type="button" className="btn min_outlin_btn active" onClick={(e)=> window.location.href=(getParameter("account_type")=="auctions"?'/wps/portal/web/login-page?account_type=auctions&reg=yes':(props.loginUrl && props.loginUrl !== ''?props.loginUrl:'/wps/portal/web/login-page'))}>
                {t("done_btn")} <i className="fa fa-arrow-right" aria-hidden="true"></i>
            </button>
        </section>
    ) 
};

export default withTranslation()(SuccessScreen);


